
import type { PropType } from 'vue'
import { defineComponent } from 'vue'

// > services/types <
import { WaybillStatus } from '@/modern/modules/m-dispatcher-module/services/types/waybill.types'

export default defineComponent({
    props: {
        status: {
            type: [Object, null] as PropType<WaybillStatus | null>,
            default: null
        },
    },
    setup(props) {
        const getColor = () => {
            if (props.status) {
                if (props.status.id === 60) {
                    return 'green'
                }

                if (props.status.id === 61) {
                    return 'red'
                }

                if (props.status.id === 62) {
                    return 'orange'
                }

                if (props.status.id === 63) {
                    return 'royal-blue'
                }
            }

            return 'gray'
        }

        return {
            getColor
        }
    }
})
